/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckedIn/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import * as fromFlow from 'Simple/Flow'
import Name from './Name/index'
import React from 'react'
import Time from './Time/index'
import Timeout from 'DesignSystem/Timeout/react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function CheckedIn({
  children,
  viewPath = "/App/Account/CheckedIn"
  
}) {
  let isBefore = useIsBefore()
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<button
  data-testid="CheckedIn.Vertical"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Start'))}
 {...isHoveredBind}
 style={{'--o-1-Z2eD7BV': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="CheckedIn.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<span
  data-testid="CheckedIn.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
You are checked-in
</span>
<span
  data-testid="CheckedIn.Text:1"
  data-view-path={viewPath}
 className={`views-text ${styles.Text1}`}
>
Please have a seat in the waiting area and you will be called for your appointment at
</span>
<Time
  viewPath={`${viewPath}/Time`}
/>
</div>
<Timeout
  viewPath={`${viewPath}/Timeout`}
 onTimeout={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Start'))}
 delay={10000}
/>
</button>
{children}
</React.Fragment>)
}